import React, { useState, useEffect, useCallback } from "react";
import "../css/inicio.css";
import TitleBar from "../Components/TitleBar";
import AppBar from "../Components/AppBar";
import { useLocation, Outlet } from "react-router-dom";
import UserInfo from "../Components/UserInfo";
import tituloIMG from "../../SVG/TitleImage.svg";
import tituloIMGSolicitud from "../../SVG/TitleImage2.svg";
import { useDispatch, useSelector } from "react-redux";
import { obtenerUsuarioActual } from "../../redux/usuariosSlice";
import { obtenerNotificacionesUsuario } from "../../redux/usuariosSlice";
import { getHomepage, getEditUser, getConfiguration, getSolicitudPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { Skeleton } from "antd";
import { StrapiError } from './StrapiError';

export default function Inicio(props) {
  const { usuario } = useSelector((state) => state.usuarios);
  const dispatch = useDispatch();
  const { locale } = useLocale();
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [hasError, setHasError] = useState(false);

  const [section, setSection] = useState("ADMISIONES");
  const [image, setImage] = useState(tituloIMG);
  const [secciones, setSecciones] = useState([
    { id: 1, titulo: "ADMISIONES", url: "", img: tituloIMG },
    { id: 2, titulo: "EDITAR USUARIO", url: "userInfo", img: tituloIMG },
    { id: 3, titulo: "CONFIGURACIÓN", url: "configuracion", img: tituloIMG },
    {
      id: 4,
      titulo: "NUEVA SOLICITUD",
      url: "Solicitud",
      img: tituloIMGSolicitud,
    },
  ]);

  const location = useLocation();

  useEffect(() => {
    dispatch(obtenerUsuarioActual());
    dispatch(obtenerNotificacionesUsuario());
  }, [dispatch]);

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    
    // Timeout para evitar carga eterna
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 5000);
    
    Promise.all([getHomepage(locale), getEditUser(locale), getConfiguration(locale), getSolicitudPage(locale)])
      .then(([homeRes, editRes, settingRes, solicitudRes]) => {
        clearTimeout(timeoutId);
        if (cancel) return;
        const homepage = homeRes?.data?.attributes || homeRes?.data || homeRes;
        const edituser = editRes?.data?.attributes || editRes?.data || editRes;
        const setting =  settingRes?.data?.attributes || settingRes?.data || settingRes;
        const solicitud = solicitudRes?.data?.attributes || solicitudRes?.data || solicitudRes;
        if (!cancel) {
          setIsLoadingContent(false);
        }
        setSecciones((prev) => prev.map((s) => {
          if (s.id === 1) return { ...s, titulo: homepage?.heroTitle || s.titulo };
          if (s.id === 2) return { ...s, titulo: edituser?.title || s.titulo };
          if(s.id === 3) return { ...s, titulo: setting?.title || s.titulo};
          if(s.id === 4) return {...s, titulo: solicitud?.title || s.titulo};
          return s;
        }));
      })
      .catch((error) => {
        clearTimeout(timeoutId);
        if (!cancel) {
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => { 
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  const verifyURL = useCallback(() => {
    let a = location.pathname;
    var x = a.split("/");
    let e;
    e = secciones.find((b) => b.url === x[1]);

    if (e !== undefined) {
      setSection(e.titulo);
      setImage(e.img);
    }
  }, [location.pathname, secciones]);

  useEffect(() => {
    verifyURL();
  }, [location, verifyURL]);

  if (isLoadingContent) {
    return (
      <div className="rootInicio">
        <AppBar />
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Skeleton active paragraph={{ rows: 4 }} />
              <Skeleton.Input style={{ width: '100%', height: 50 }} active />
              <Skeleton active paragraph={{ rows: 6 }} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (hasError && locale === 'en') {
    return <StrapiError 
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
      }}
    />
  }

  return (
    <div className="rootInicio">
      <AppBar />
      <TitleBar titulo={section} imagen={image} />
      <UserInfo usuario={usuario} />

      <Outlet />
    </div>
  );
}
